import { fromFetch } from 'rxjs/fetch';

import { csvHeaders } from '../../../models/csv-headers';
import { selectBlob } from '../../../utils/select-blob';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';

/**
 * Get a Partner License Report as a CSV file
 * @returns CSV data as Blob
 */
export function getResellerReportsLicensesCsvfile(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${
          accountsEnvironment.resolve(this).resellerReportsLicensesUrl
        }/csvfile`,
        {
          method: 'GET',
          headers: {
            ...csvHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectBlob());
}
